import { takeEvery, put, call } from 'redux-saga/effects';

import { HttpConnection } from '../../common/helper/http-connection.js'
import { URL_API } from '../../common/constants/common.js';
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* getRecordList(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getRecordList',
        parameter: {
            search: action.search,
            month: action.month,
            course: action.course,
            mode: action.mode,
        },
    }
    const data = yield call(http.post, info);
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.items);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getRecordList",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getRecordListSaga = takeEvery('GetRecordList_Saga', getRecordList);

function* getRecordHistory(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getRecordHistory',
        parameter: {
            userID: action.id,
            subjectID: action.subjectID,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.items);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getRecordHistory",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getRecordHistorySaga = takeEvery('GetRecordHistory_Saga', getRecordHistory);

function* deleteRecord(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/deleteRecord',
        parameter: {
            id: action.id,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(action.index);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "deleteRecord",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const deleteRecordSaga = takeEvery('DeleteRecord_Saga', deleteRecord);

function* saveRecord(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/saveRecord',
        parameter: {
            userID: action.userID,
            subjectID: action.subjectID,
            audio: action.audio,
        },
    }
    const data = yield call(http.post, info);
    
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.item);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "saveRecord",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const saveRecordSaga = takeEvery('SaveRecord_Saga', saveRecord);

function* sendRecord(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/sendRecord',
        parameter: {
            id: action.id,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "sendRecord",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const sendRecordSaga = takeEvery('SendRecord_Saga', sendRecord);

function* saveComment(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/saveComment',
        parameter: {
            id: action.id,
            comment: action.comment,
            cancelFlg: action.cancelFlg,
            charge: action.charge,
        },
    }
    const data = yield call(http.put, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "saveComment",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const saveCommentSaga = takeEvery('SaveComment_Saga', saveComment);

function* sendComment(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/sendComment',
        parameter: {
            id: action.id,
            userID: action.userID,
            from: action.from,
        },
    }
    const data = yield call(http.put, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "sendComment",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const sendCommentSaga = takeEvery('SendComment_Saga', sendComment);

function* getCommentList(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getCommentList',
        parameter: {
            id: action.id
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.items);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getCommentList",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getCommentListSaga = takeEvery('GetCommentList_Saga', getCommentList);
